




































import Scope from '@/views/atoms/Scope.vue'
import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import PopupCircleEpisode from '@/views/templates/kuntama/PopupCircleEpisode.vue'

export default
  components: {
    Scope
    EpisodeTitle
    PopupCircleEpisode
  }

  data: () ->
    targetID: -1
    title: [
      [
        'おいしさの秘訣'
      ]
      [
        'おいしさの秘訣'
      ]
      [
        'おいしさの秘訣'
      ]
      [
        'おいしさの秘訣'
      ]
    ]
    titlePoint: [
      [
        'POINT . 01'
      ]
      [
        'POINT . 02'
      ]
      [
        'POINT . 03'
      ]
      [
        'POINT . 04'
      ]
    ]
    subtitle: [
      [
        '採れたての「新鮮たまご」'
      ]
      [
        '旨みの浸透を促す「塩」'
      ]
      [
        '優れた風味の「北海道産昆布」'
      ]
      [
        'たまごの風味を活かす'
        '「燻製チップ」'
      ]
    ]
    message: [
      [
        'たまごは契約農家から仕入れた、毎朝採れたての新鮮たまごを使用しています。'
        'たっぷり餌を食べた母鶏から産まれるたまごは、ほのかな甘みと濃縮された旨みが特徴です。'
      ]
      [
        '塩は、殻のひび割れを防ぐとともに、たまごの主成分であるたんぱく質を凝固させる働きもあります。また、旨みの浸透や殺菌効果なども促します。'
      ]
      [
        'たまご本来の味わいを活かすために、北海道産昆布を取り寄せて、だしに使用しています。クセがなく、優れた風味の北海道産昆布は、素材の旨みを引き立てます。'
      ]
      [
        '燻製チップは、国産広葉樹チップを主にしたオリジナルブレンド。豊かな木の香りと色付きの良さが自慢です。'
        'チップにとって湿気は大敵なので、倉庫に積み上げられたチップを「天地返し」して、含水率をコントロールしています。'
      ]
    ]
    images: [
      '/assets/image/kuntama/episode5_popup1.png'
      '/assets/image/kuntama/episode5_popup2.png'
      '/assets/image/kuntama/episode5_popup3.png'
      '/assets/image/kuntama/episode5_popup4.png'
    ]
    points: [
      'p4-3'
      'p4-4'
      'p4-5'
      'p4-6'
    ]
  methods: {
    showPopup: (target) ->
      @targetID = target
    closePopup: () ->
      @targetID = -1
    addPoint: (point) ->
      @$emit('addPoint', point)
  }
